import { THEME_PREVIEW_OFFSET_LIVEVIEW } from 'constants/common.const';
import { THEME_LIVEVIEW_WRAPPER_SCALE } from 'constants/photo.const';
import { useBoothAppContext } from 'context/BoothAppContext';
import { calcBgSliceByPosition } from 'helpers/math.helper';
import { resourceUrl } from 'helpers/url.helper';
import { size } from 'lodash';
import React, { useMemo } from 'react';

export type ShowThemeProps = {
  liveviewSize?: { width: number; height: number };
  takingPhotoIndex: number;
  isShowInLiveView?: boolean; // Theme hiển thị trên liveview, để check khác với theme trên thumbnail
};

const ShowThemeOnArea = ({
  liveviewSize,
  takingPhotoIndex,
  isShowInLiveView,
}: ShowThemeProps) => {
  const { currentLayout } = useBoothAppContext();

  const scaleOfWebcamFrameWrapper = useMemo(
    () => (isShowInLiveView ? THEME_LIVEVIEW_WRAPPER_SCALE : 1),
    [isShowInLiveView],
  );

  const widthOffset = useMemo(() => {
    if (!isShowInLiveView) return 0;

    return (
      ((THEME_PREVIEW_OFFSET_LIVEVIEW / (currentLayout?.width || 1)) *
        (liveviewSize?.width || 0)) /
      (1 - THEME_PREVIEW_OFFSET_LIVEVIEW / (currentLayout?.width || 1))
    );
  }, [currentLayout?.width, isShowInLiveView, liveviewSize?.width]);

  const heightOffset = useMemo(() => {
    if (!isShowInLiveView) return 0;

    return (
      ((THEME_PREVIEW_OFFSET_LIVEVIEW / (currentLayout?.height || 1)) *
        (liveviewSize?.height || 0)) /
      (1 - THEME_PREVIEW_OFFSET_LIVEVIEW / (currentLayout?.height || 1))
    );
  }, [currentLayout?.height, isShowInLiveView, liveviewSize?.height]);

  //   tinh toan cat background theme tren liveview
  const backgroundSliceProps = useMemo(
    () =>
      calcBgSliceByPosition(
        currentLayout,
        {
          width:
            (1 / scaleOfWebcamFrameWrapper) * (liveviewSize?.width || 0) +
            2 * widthOffset,
          height:
            (1 / scaleOfWebcamFrameWrapper) * (liveviewSize?.height || 0) +
            2 * heightOffset,
        },
        takingPhotoIndex % size(currentLayout?.pictures),
        THEME_PREVIEW_OFFSET_LIVEVIEW,
      ),
    [
      currentLayout,
      heightOffset,
      liveviewSize?.height,
      liveviewSize?.width,
      takingPhotoIndex,
      scaleOfWebcamFrameWrapper,
      widthOffset,
    ],
  );

  return (
    <div
      className="liveview-theme-preview"
      style={{
        backgroundImage: `url(${resourceUrl(currentLayout?.image)})`,
        backgroundPosition: backgroundSliceProps?.backgroundPosition,
        backgroundSize: backgroundSliceProps?.backgroundSize,
        top: -heightOffset,
        left: -widthOffset,
        width: `calc(100% + ${2 * widthOffset}px)`,
        height: `calc(100% + ${2 * heightOffset}px)`,
        ...(!liveviewSize?.width && { display: 'none' }),
      }}
    />
  );
};

export default ShowThemeOnArea;
